export default __webpack_public_path__ + "f93fcdbb3a53fba96b97b71f69d68d43.png";